import React,{useMemo,useState} from 'react';
import {currentDragons} from '../utils/dragons';
import {PCFilters} from './PC28Controls';
import {ResultText} from './ResultText';
export function PC28DragonPage({history,disabled}) {
  const [type,setType]=useState('all');
  const runs=useMemo(()=>disabled?[]:currentDragons(history,'pc'),[history,disabled]);
  const visible=type==='all'?runs:runs.filter(run=>run.type===type);
  return <>
    <PCFilters label="长龙类型" items={['全部','连续','交替','ABB循环'].map((label,i)=>[i?label:'all',label])} value={type} onChange={setType}/>
    <p className="pc-sample-note">连续至少3期、交替至少4期、ABB循环至少6期。只展示延续至最新一期的序列；缺期或“和”会中断，不把单次变化当成交替。</p>
    <div className="pc-dragon-grid">{visible.map(run=><article className="pc-dragon-card" key={run.id}>
      <div className="pc-dragon-heading"><strong>{run.label==='双组'?'组合':run.label}</strong><span>{run.type} · {run.count}期</span><em>进行中</em></div>
      <div className="pc-dragon-sequence">{run.sequence.map((value,i)=><ResultText value={value} key={i}/>)}</div>
      <p>{run.start} – {run.end} · 由旧到新</p>
      {run.atLeast&&<p>序列已到样本起点，可能始于更早期。</p>}
    </article>)}</div>
    {!visible.length&&<p className="empty-state">{disabled?'等待完整、连续的开奖数据':'当前没有符合条件的长龙'}</p>}
  </>;
}
